// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__p51iD","icon":"Navbar_icon__5D6Kl","linkText":"Navbar_linkText__D+UIG","unreadCount":"Navbar_unreadCount__IhCvV"};